import * as React from "react";
import Iconify from "../../iconify";
import IconCode from "@/src/lib/iconCode";
import useAuth from "@/src/lib/hooks/useAuth";
import useCheckoutHook from "@/src/lib/module-helper/my-account/hook/useCheckkoutHook";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";

const CartDrawer = dynamic(() => import("./cartDrawer"));
const CartDrawerForLoggedInCart = dynamic(() =>
    import("./cartDrawerForLoggedInCart")
);

export default function BasicMenu() {
    const [anchorEl, setAnchorEl] = React.useState(false);
    const [openCart, setOpenCart] = React.useState(false);
    const { isLoggedIn } = useAuth();
    const [badgeCount, setBadgeCount] = React.useState(0);
    const { checkoutData, cartCountData, refetchCheckoutData, showLoader } =
        useCheckoutHook();

    const cartCount = cartCountData?.data?.cartCount || 0;
    const checkoutLines = checkoutData?.data?.data || {};

    const { homeCart, centreCart } = checkoutLines || {};

    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        if (!isLoggedIn) {
            setOpenCart(true);
        } else {
            setAnchorEl(true);
            refetchCheckoutData();
        }
        //setAnchorEl(event.currentTarget);
    };

    const handleCloseCart = () => {
        setOpenCart(false);
    };

    const handleClose = () => {
        setAnchorEl(false);
    };

    const loggedoutCartCount = useSelector(
        (state) => state?.addToCart?.addProducts?.centreTest
    )?.length;

    React.useEffect(() => {
        const badgeCountData = isLoggedIn
            ? cartCount
                ? cartCount
                : 0
            : loggedoutCartCount
            ? loggedoutCartCount
            : 0;
        setBadgeCount(badgeCountData);
    }, [isLoggedIn, loggedoutCartCount, cartCount]);

    return (
        <>
            <div className="relative cursor-pointer" onClick={handleClick}>
                {Boolean(badgeCount) && (
                    <div className="w-5 h-5 bg-primary rounded-full flex items-center justify-center text-white text-xs font-bold absolute -top-3 -right-2">
                        {badgeCount}
                    </div>
                )}
                <Iconify icon={IconCode.cart} color="black" size={24} />
                {/* </Badge> */}
            </div>
            <CartDrawer openCart={openCart} handleCloseCart={handleCloseCart} />
            <CartDrawerForLoggedInCart
                anchorEl={anchorEl}
                handleClose={handleClose}
                homeCart={homeCart}
                centreCart={centreCart}
                refetchCheckoutData={refetchCheckoutData}
                showLoader={showLoader}
                checkoutData={checkoutData}
            />
        </>
    );
}
